module.exports = __webpack_public_path__ + "static/media/logo_transparent_background.0fdf4895.png";